import { Avatar } from "@mui/material";
import React from "react";
import { motion } from "framer-motion";
import avatarPlaceholder from "./../../../../../Assets/avatar-placeholder.png";
import signature from "./../../../../../Assets/dummy-signature.png";
import CustomAction from "../../../../controls/CustomAction";
import useBookingApp from "../../../../../hooks/useBookingApp";

export default function ChatSuggestions({
  mainColor,
  activeStep,
  PCactiveStep,
  countrySelectionMessages,
  secondaryColor,
  enableDateTimeSelection,
  preConsultation,
  setPreConsultation,
}) {
  const { bookingSectionState } = useBookingApp();
  const { companyDetails, bookingModel, isEnablePrePayment } = bookingSectionState;
  const pharmacyName = companyDetails?.pharmacies[0].pharmacyName;

  const messagesToDisplay = (activeStep) => {
    const isPrePaymentEnabled = isEnablePrePayment;

    switch (activeStep) {
      case 2:
        return countrySelectionMessages;

      case 3:
        return enableDateTimeSelection
          ? [
            `${bookingModel?.FirstName}, we'd always recommend booking your appointment much earlier than you think you need! 📅 This is because some vaccines take between 1 - 2 weeks to take effect ⏳. So, if you're travelling in 2 weeks, you'll want to book your appointment at least 3 weeks before you leave! ✈️`,
          ]
          : [
            `Hey ${bookingModel?.FirstName}, before we can let you choose a date and time, let us know which Branch you’d prefer to have your vaccine.`,
          ];

      case 4:
        return isPrePaymentEnabled
          ? [
            "Your booking will be confirmed as soon as the deposit payment is complete! 🎉",
          ]
          : [
            `You’re all set, ${bookingModel?.FirstName}. We are really looking forward to seeing you soon!`,
            "Just a heads up, we will send you a pre-consultation form to fill out before your appointment. Keep an eye on your email!",
          ];

      case 5:
        if (isPrePaymentEnabled) {
          return [
            `You’re all set, ${bookingModel?.FirstName}. We are really looking forward to seeing you soon!`,
            "Just a heads up, we will send you a pre-consultation form to fill out before your appointment. Keep an eye on your email!",
          ];
        } else {
          return [];
        }

      default:
        return [];
    }
  };

  const PCmessagesToDisplay = (PCactiveStep) => {
    switch (PCactiveStep) {
      case 1:
        return [
          "Just giving you a heads up you will be required to have a Yellow Fever Vaccine to enter Brazil.",
        ];
      default:
        return [];
    }
  };

  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: "spring", stiffness: 100, delay: 0.9 }}
      exit={{ y: 10, opacity: 0 }}
      className="chat-suggestions-wrapper"
    >
      <div className="scroll-wrapper">
        <motion.div
          className="messages-wrapper"
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: {
                delayChildren: 2,
                staggerChildren: 0.2,
              },
            },
          }}
        >
          {(preConsultation
            ? PCmessagesToDisplay(PCactiveStep)
            : messagesToDisplay(activeStep)
          )?.map((message, index) => (
            <motion.div
              key={index}
              className="message"
              style={{
                background: `linear-gradient(to bottom right, ${secondaryColor}60, ${secondaryColor} 100%)`,
              }}
              initial={{
                rotate: 3,
                transformOrigin: "50% 100%",
                opacity: 0,
              }}
              animate={{
                rotate: 0,
                transformOrigin: "100%",
                opacity: 1,
              }}
              transition={{
                ease: "easeOut",
                duration: 0.3,
              }}
            >
              <p>{message}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
      {activeStep === 4 && (
        <div className="form-success-btn">
          <CustomAction
            text="Start pre-consultation"
            mainColor={mainColor}
            action={() => {
              setPreConsultation(true);
            }}
          />
        </div>
      )}

      <div className="pharmacist">
        <div className="pharmacist-info">
          <div className="pharmacist-avatar">
            <Avatar
              src={avatarPlaceholder}
              alt="Pharmacist Avatar"
              sx={{ width: 42, height: 42 }}
            />
          </div>

          <div className="pharmacist-name">
            <p>Eddie</p>
            <span>Pharmacist @ {pharmacyName}</span>
          </div>
        </div>
        <div className="pharmacist-signature">
        </div>
      </div>
    </motion.div>
  );
}
